import './App.css';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { AppRouter } from './Router';
import { Provider, useSelector } from 'react-redux';
import { RootState, store } from './redux/store';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import { useEffect } from 'react';
// const casConfig = {
//   casServer: process.env.REACT_APP_CAS!,
//   service: process.env.REACT_APP_FRONT!,
// }





// const App = ({  }) => {
//   return (
//     // <CasProvider config ={casConfig}>
//     //   <Provider store={store}>
//     <MsalProvider instance={instance}>
//       <BrowserRouter>
//         <AppRouter />
//       </BrowserRouter>
//     </MsalProvider>

      
//     //   </Provider>

//     // </CasProvider>
    
//   );
// };

const App = ({ })=>{

  return(

    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );

};

export default App;
